import React, { useEffect, useState } from "react";
import { Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import {
  sortCaret,
  headerSortingClasses,
  PleaseWaitMessage,
  NoRecordsFoundMessage,
} from "../../../_metronic/_helpers";
import { useDispatch, useSelector } from "react-redux";

import { useHistory } from "react-router-dom";
import {
  sizePerPageList,
  showSuccessDialog,
  showErrorDialog,
  activeFormatter,
  showConfirmDialog,
  formatDate,
  lockedFormatter,
  showDeleteDialog,
  iconError,
  checkPermision,
} from "../../utility";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import LoadingFetchData from "../../utility/LoadingFetchData";
import SVG from "react-inlinesvg";
import { Button, Col, Row } from "react-bootstrap";

import { FormHelperText, TextField } from "@material-ui/core";
// MUI
import {
  fade,
  withStyles,
  makeStyles,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";
import {
  addLocationMaster,
  editCountry,
  editLocationMaster,
  removeCountry,
  removeLocationMaster,
  selectCountryAll,
  selectPermissionLocationMaster,
} from "./locationSlice";
import { Autocomplete } from "@material-ui/lab";
import { selectParameter } from "../businessParameter/businessParameterSlice";

const useStylesReddit = makeStyles((theme) => ({
  root: {
    border: "1px solid #e2e2e1",
    overflow: "hidden",
    borderRadius: 4,
    backgroundColor: "#FFFFFF",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    "&:hover": {
      backgroundColor: "#fff",
    },
    "&$focused": {
      backgroundColor: "#fff",
      boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 2px`,
      borderColor: theme.palette.primary.main,
    },
  },
  focused: {},
}));

const formLabelsTheme = createMuiTheme({
  overrides: {
    MuiFormLabel: {
      asterisk: {
        color: "#db3131",
        "&$error": {
          color: "#db3131",
        },
      },
    },
    MuiFormHelperText: {
      root: {
        margin: "1px !important", // Remove the margin
      },
    },
  },
  typography: {
    fontFamily: `"Poppins", "Helvetica", "Arial", sans-serif`,
  },
});

function RedditTextField(props) {
  const classes = useStylesReddit();

  return (
    <TextField InputProps={{ classes, disableUnderline: true }} {...props} />
  );
}
const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  margin: {
    margin: theme.spacing(1),
  },
}));

export const LocationMasterTable = ({
  data,
  page,
  sizePerPage,
  sortField,
  sortOrder,
  onTableChange,
  totalSize,
  loading,
  handleSearch,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const classes = useStyles();
  const dataCountry = useSelector(selectCountryAll);
  const permission = useSelector(selectPermissionLocationMaster);
  const dataLocation = useSelector(selectParameter);

  useEffect(() => {
    // Add number
    const pageBefore = sizePerPage * (page - 1);
    const initData = data.map((item, index) => {
      return {
        ...item,
        no: index + 1 + pageBefore,
      };
    });
    setTableData(initData);
  }, [data, sizePerPage, page]);

  const [tableData, setTableData] = useState(data);

  const handleDelete = async (e, row) => {
    const params = { locationmaster_id: `${row.locationmaster_id}` };
    const action = await showDeleteDialog(`Are you sure you want to delete?`);
    if (action.isConfirmed) {
      try {
        const response = await dispatch(removeLocationMaster({ data: params }));
        if (response.payload.data.status === 200) {
          const action = await showSuccessDialog(response.payload.data.message);
          await handleSearch();
        } else {
          showErrorDialog(response.payload.data.message);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const actionFormatter = (e, row, rowIndex, formatExtraData) => {
    return (
      <>
        <div>
          {/* <OverlayTrigger
            overlay={<Tooltip id="products-edit-tooltip">View</Tooltip>}
          >
            <a
              className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3 mb-1"
              onClick={() => {
                history.push(
                  `/administration/office-management/view/${row.office_id}`
                );
              }}
            >
              <span className="svg-icon svg-icon-md svg-icon-light">
                <SVG
                  src={toAbsoluteUrl( "/media/svg/icons/New/Search.svg")}
                />
              </span>
            </a>
          </OverlayTrigger> */}

          {checkPermision(permission, "UPDATE") && (
            <>
              {row.is_enable === "Y" && (
                <OverlayTrigger
                  overlay={<Tooltip id="products-edit-tooltip">Edit</Tooltip>}
                >
                  <div
                    className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3"
                    onClick={(e) => {
                      setFormValues({
                        locationmaster_id: {
                          value: row.locationmaster_id,
                          error: false,
                          required: "Y",
                        },
                        locationmaster_code: {
                          value: row.locationmaster_code,

                          error: false,
                          required: "Y",
                        },
                        locationmaster_name: {
                          value: row.locationmaster_name,

                          error: false,
                          required: "Y",
                        },
                        locationmaster_country: {
                          value: row.locationmaster_country,

                          error: false,
                          required: "Y",
                        },
                        locationmaster_type: {
                          value: row.locationmaster_type,

                          error: false,
                          required: "N",
                        },
                        locationmaster_latitude: {
                          value: row.locationmaster_latitude,

                          error: false,
                          required: "N",
                        },
                        locationmaster_longitude: {
                          value: row.locationmaster_longitude,

                          error: false,
                          required: "N",
                        },
                        locationmaster_city: {
                          value: row.locationmaster_city,

                          error: false,
                          required: "N",
                        },
                        locationmaster_uncode: {
                          value: row.locationmaster_uncode,

                          error: false,
                          required: "N",
                        },
                      });
                      setShow(true);
                    }}
                  >
                    <span className="svg-icon svg-icon-md svg-icon-light">
                      <SVG
                        src={toAbsoluteUrl("/media/svg/icons/New/edit.svg")}
                      />
                    </span>
                  </div>
                </OverlayTrigger>
              )}
            </>
          )}

          {checkPermision(permission, "DELETE") && (
            <>
              {row.is_enable === "Y" && (
                <OverlayTrigger
                  overlay={
                    <Tooltip id="products-delete-tooltip">Delete</Tooltip>
                  }
                >
                  <div
                    className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3"
                   onClick={(e) =>
                      handleDelete(e, row )
                    }
                  >
                    <span className="svg-icon svg-icon-md svg-icon-light">
                      <SVG
                        src={toAbsoluteUrl("/media/svg/icons/New/delete.svg")}
                      />
                    </span>
                  </div>
                </OverlayTrigger>
              )}
            </>
          )}

          {checkPermision(permission, "UPDATE") && (
            <>
              {row.is_enable === "Y" && (
                <OverlayTrigger
                  overlay={
                    <Tooltip id="products-edit-tooltip">Disabled</Tooltip>
                  }
                >
                  <div
                    className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3"
                    onClick={() => handleDisabled(e, row, rowIndex)}
                  >
                    <span className="svg-icon svg-icon-md svg-icon-light">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/New/eye-slash.svg"
                        )}
                      />
                    </span>
                  </div>
                </OverlayTrigger>
              )}
              {row.is_enable === "N" && (
                <OverlayTrigger
                  overlay={
                    <Tooltip id="products-edit-tooltip">Enabled</Tooltip>
                  }
                >
                  <div
                    className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3"
                    onClick={() => handleEnable(e, row, rowIndex)}
                  >
                    <span className="svg-icon svg-icon-md svg-icon-light">
                      <SVG
                        src={toAbsoluteUrl("/media/svg/icons/New/eye.svg")}
                      />
                    </span>
                  </div>
                </OverlayTrigger>
              )}
            </>
          )}
        </div>
      </>
    );
  };

  const handleDisabled = async (e, row, rowIndex) => {
    const params = {
      locationmaster_id: row.locationmaster_id,
      is_enable: "N",
    };
    console.log(params);

    const action = await showConfirmDialog(`Are you sure want to disabled?`);
    if (action.isConfirmed) {
      try {
        const response = await dispatch(editLocationMaster(params));
        if (response.payload.status === 200) {
          const action = await showSuccessDialog(response.payload.message);
          await handleSearch();
        } else {
          showErrorDialog(response.payload.data.message);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };
  const handleEnable = async (e, row, rowIndex) => {
    const params = {
      locationmaster_id: row.locationmaster_id,
      is_enable: "Y",
    };
    console.log(params);

    const action = await showConfirmDialog(`Are you sure want to enable?`);
    if (action.isConfirmed) {
      try {
        const response = await dispatch(editLocationMaster(params));
        if (response.payload.status === 200) {
          const action = await showSuccessDialog(response.payload.message);
          await handleSearch();
        } else {
          showErrorDialog(response.payload.data.message);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };
  const columns = [
    {
      text: "No",
      dataField: "no",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "60px" },
    },
    {
      text: "Code",
      dataField: "locationmaster_code",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Name",
      dataField: "locationmaster_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Type",
      dataField: "locationmaster_type_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "City",
      dataField: "locationmaster_city",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Country",
      dataField: "country_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Latitude",
      dataField: "locationmaster_latitude",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Longitude",
      dataField: "locationmaster_longitude",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "UN Code",
      dataField: "locationmaster_uncode",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },

    {
      dataField: "actions",
      text: "Actions",
      formatter: actionFormatter,
      style: { minWidth: "200px" },
      headerAlign: "center",
      align: "center",
    },
  ];



  const options = {
    page: page < 0 ? 1 : page,
    sizePerPage: sizePerPage,
    showTotal: true,
    totalSize: totalSize,
    sizePerPageList: sizePerPageList(totalSize),
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: {
        ...formValues[name],
        value,
      },
    });
  };

  const validatePost = (e) => {
    let isValid = true;

    const formFields = Object.keys(formValues);
    let newFormValues = { ...formValues };

    for (let index = 0; index < formFields.length; index++) {
      const currentField = formFields[index];
      const currentValue = formValues[currentField].value;
      const required = formValues[currentField].required;

      if (currentValue === "" && required === "Y") {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            error: true,
          },
        };
        isValid = false;
      } else {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            error: false,
          },
        };
      }
    }

    setFormValues(newFormValues);

    console.log(isValid, "isValid");
    return isValid;
  };

  const [formValues, setFormValues] = useState({
    locationmaster_id: {
      value: "",
      error: false,
      required: "Y",
    },
    locationmaster_code: {
      value: "",
      error: false,
      required: "Y",
    },
    locationmaster_name: {
      value: "",
      error: false,
      required: "Y",
    },
    locationmaster_country: {
      value: "",
      error: false,
      required: "Y",
    },
    locationmaster_type: {
      value: "",
      error: false,
      required: "N",
    },
    locationmaster_latitude: {
      value: "",
      error: false,
      required: "N",
    },
    locationmaster_longitude: {
      value: "",
      error: false,
      required: "N",
    },
    locationmaster_city: {
      value: "",
      error: false,
      required: "N",
    },
    locationmaster_uncode: {
      value: "",
      error: false,
      required: "N",
    },
  });
  const handleSave = async () => {
    
    if (!validatePost()) {
      return;
    }
    if (
      formValues.locationmaster_code.value.includes("<script>") ||
      formValues.locationmaster_code.value.includes("</script>")
    ) {
      return showErrorDialog("please don't input value <script>");
    }
    if (
      formValues.locationmaster_name.value.includes("<script>") ||
      formValues.locationmaster_name.value.includes("</script>")
    ) {
      return showErrorDialog("please don't input value <script>");
    }

    const params = {
      locationmaster_id: formValues.locationmaster_id.value,
      locationmaster_code: formValues.locationmaster_code.value,
      locationmaster_name: formValues.locationmaster_name.value,
      locationmaster_country: formValues.locationmaster_country.value,
      locationmaster_type: formValues.locationmaster_type.value,
      locationmaster_latitude: formValues.locationmaster_latitude.value,
      locationmaster_longitude: formValues.locationmaster_longitude.value,
      locationmaster_city: formValues.locationmaster_city.value,
      locationmaster_uncode: formValues.locationmaster_uncode.value,
    };

    try {
      const response = await dispatch(editLocationMaster(params));

      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        await handleClose();
        await handleSearch();
      } else {
        await showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const handleDuplicate = async () => {
    if (!validatePost()) {
      return;
    }

    const params = {
      // locationmaster_id: formValues.locationmaster_id.value,
      locationmaster_code: formValues.locationmaster_code.value,
      locationmaster_name: formValues.locationmaster_name.value,
      locationmaster_country: formValues.locationmaster_country.value,
      locationmaster_type: formValues.locationmaster_type.value,
      locationmaster_latitude: formValues.locationmaster_latitude.value,
      locationmaster_longitude: formValues.locationmaster_longitude.value,
      locationmaster_city: formValues.locationmaster_city.value,
      locationmaster_uncode: formValues.locationmaster_uncode.value,
    };

    try {
      const response = await dispatch(addLocationMaster(params));

      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        await handleClose();
        await handleSearch();
      } else {
        await showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const [show, setShow] = useState(false);

  const handleClose = () => {
    setFormValues({
      locationmaster_id: {
        value: "",
        error: false,
        required: "Y",
      },
      locationmaster_code: {
        value: "",
        error: false,
        required: "Y",
      },
      locationmaster_name: {
        value: "",
        error: false,
        required: "Y",
      },
      locationmaster_country: {
        value: "",
        error: false,
        required: "Y",
      },
      locationmaster_type: {
        value: "",
        error: false,
        required: "N",
      },
      locationmaster_latitude: {
        value: "",
        error: false,
        required: "N",
      },
      locationmaster_longitude: {
        value: "",
        error: false,
        required: "N",
      },
      locationmaster_city: {
        value: "",
        error: false,
        required: "N",
      },
      locationmaster_uncode: {
        value: "",
        error: false,
        required: "N",
      },
    });
    setShow(false);
  };

  const handleChangeCountry = (e, params) => {
    const value = params.value;
    const name = params.label;
    setFormValues({
      ...formValues,
      ["locationmaster_country"]: {
        ...formValues["locationmaster_country"],
        value,
      },
    });
  };
  const handleChangeType = (e, params) => {
    const value = params.value;
    const name = params.label;
    setFormValues({
      ...formValues,
      ["locationmaster_type"]: {
        ...formValues["locationmaster_type"],
        value,
      },
    });
  };

  const countryOptions = dataCountry.map((e) => {
    return {
      value: e.country_id,
      label: e.country_name,
    };
  });
  const locationOptions = dataLocation.map((e) => {
    return {
      value: e.param_code,
      label: e.param_value,
    };
  });

  const index = countryOptions.findIndex(
    (obj) => obj.value === formValues.locationmaster_country.value
  );

  const indexLocation = locationOptions.findIndex(
    (obj) => obj.value === formValues.locationmaster_type.value
  );

  return (
    <>
      <BootstrapTable
        remote
        wrapperClasses="table-responsive"
        classes="table table-head-custom table-vertical-center overflow-hidden rounded mt-4"
        bootstrap4
        
        keyField="locationmaster_id"
        data={tableData}
        columns={columns}
        pagination={paginationFactory(options)}
        onTableChange={onTableChange}
        sort={{ dataField: sortField, order: sortOrder }}
        hover
        striped
      >
        <PleaseWaitMessage entities={loading ? null : tableData} />
        <NoRecordsFoundMessage entities={loading ? null : tableData} />
      </BootstrapTable>
      {/* Footer */}
      <Modal
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={show}
        onHide={handleClose}
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter text-white">
            Edit Location Master
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ThemeProvider theme={formLabelsTheme}>
            <div>
              <Row>
                <Col xs={12} sm={3} md={6} lg={6}>
                  {" "}
                  <RedditTextField
                    required
                    label="Code"
                    className={classes.margin}
                    variant="filled"
                    id="reddit-input"
                    size="small"
                    fullWidth
                    name="locationmaster_code"
                    value={formValues.locationmaster_code.value}
                    onChange={handleChange}
                    error={formValues.locationmaster_code.error}
                    helperText={
                      formValues.locationmaster_code.error ? (
                        <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                          {iconError} {"This field is required"}
                        </FormHelperText>
                      ) : (
                        ""
                      )
                    }
                  />
                  <RedditTextField
                    required
                    label="Name"
                    className={classes.margin}
                    variant="filled"
                    id="reddit-input"
                    size="small"
                    fullWidth
                    name="locationmaster_name"
                    value={formValues.locationmaster_name.value}
                    onChange={handleChange}
                    error={formValues.locationmaster_name.error}
                    helperText={
                      formValues.locationmaster_name.error ? (
                        <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                          {iconError} {"This field is required"}
                        </FormHelperText>
                      ) : (
                        ""
                      )
                    }
                  />
                  <Autocomplete
                    disablePortal
                    name="locationmaster_type"
                    options={locationOptions}
                    getOptionLabel={(option) => option.label.toString()}
                    disableClearable={true}
                    onChange={handleChangeType}
                    value={locationOptions[indexLocation]}
                    renderInput={(params) => (
                      <RedditTextField
                        required
                        className={classes.margin}
                        {...params}
                        label="Type"
                        id="reddit-input"
                        size="small"
                        fullWidth
                        name="locationmaster_type"
                        error={formValues.locationmaster_type.error}
                        helperText={
                          formValues.locationmaster_type.error ? (
                            <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                              {iconError} {"This field is required"}
                            </FormHelperText>
                          ) : (
                            ""
                          )
                        }
                      />
                    )}
                  />
                  {/* <RedditTextField
                      label="Select"
                      className={classes.margin}
                      variant="filled"
                      id="reddit-input"
                      size="small"
                      fullWidth
                      name="locationmaster_type"
                      value={formValues.locationmaster_type.value}
                      onChange={handleChange}
                    /> */}
                  <RedditTextField
                    label="City"
                    className={classes.margin}
                    variant="filled"
                    id="reddit-input"
                    size="small"
                    fullWidth
                    name="locationmaster_city"
                    value={formValues.locationmaster_city.value}
                    onChange={handleChange}
                  />
                </Col>
                <Col xs={12} sm={3} md={6} lg={6}>
                  <Autocomplete
                    disablePortal
                    name="locationmaster_country"
                    options={countryOptions}
                    getOptionLabel={(option) => option.label.toString()}
                    disableClearable={true}
                    onChange={handleChangeCountry}
                    value={countryOptions[index]}
                    renderInput={(params) => (
                      <RedditTextField
                        required
                        className={classes.margin}
                        {...params}
                        label="Country"
                        id="reddit-input"
                        size="small"
                        fullWidth
                        placeholder="Select Country"
                        name="locationmaster_country"
                        error={formValues.locationmaster_country.error}
                        helperText={
                          formValues.locationmaster_country.error ? (
                            <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                              {iconError} {"This field is required"}
                            </FormHelperText>
                          ) : (
                            ""
                          )
                        }
                      />
                    )}
                  />
                  <RedditTextField
                    label="Latitude"
                    className={classes.margin}
                    variant="filled"
                    id="reddit-input"
                    size="small"
                    fullWidth
                    type="number"
                    name="locationmaster_latitude"
                    value={formValues.locationmaster_latitude.value}
                    onChange={handleChange}
                  />
                  <RedditTextField
                    label="Longitude"
                    className={classes.margin}
                    variant="filled"
                    id="reddit-input"
                    size="small"
                    fullWidth
                    type="number"
                    name="locationmaster_longitude"
                    value={formValues.locationmaster_longitude.value}
                    onChange={handleChange}
                  />
                  <RedditTextField
                    label="UN Code"
                    className={classes.margin}
                    variant="filled"
                    id="reddit-input"
                    size="small"
                    fullWidth
                    name="locationmaster_uncode"
                    value={formValues.locationmaster_uncode.value}
                    onChange={handleChange}
                  />
                </Col>
              </Row>
            </div>
          </ThemeProvider>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="outline-primary" onClick={handleDuplicate}>
            Duplicate
          </Button>
          <Button variant="primary" onClick={handleSave}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
